import I18N_STRINGS from 'Jsx/CheckoutV4/i18n/language';
import { CountryPrefixEnum } from 'Jsx/CheckoutV4/types';

export interface ZipCodeValidation {
  formattedValue: string;
  errorState: {
    message: string;
    error: boolean;
  };
}

const validateBrasilZipCode = (zipCode: string) => {
  let formattedValue = zipCode.replace(/[^0-9]/g, '');

  if (formattedValue.length === 5 && zipCode.charAt(5) === '-') {
    formattedValue += '-';
  } else if (formattedValue.length > 5) {
    formattedValue = [formattedValue.slice(0, 5), formattedValue.slice(5)].join(
      '-',
    );
  }

  const regex = new RegExp('^([0-9]{5}-[0-9]{3})$');

  const isValid = formattedValue.match(regex);
  let message = '';

  if (formattedValue.length === 0) message = I18N_STRINGS.REQUIRED_ZIP_CODE;
  else if (!isValid) message = I18N_STRINGS.INVALID_ZIP_CODE;

  return {
    formattedValue,
    errorState: {
      message,
      error: !isValid,
    },
  };
};

const validateZipCode = ({
  country,
  value,
}: {
  country: string;
  value: string;
}): ZipCodeValidation => {
  if (country === CountryPrefixEnum.BRASIL) {
    return validateBrasilZipCode(value);
  }

  let message = '';

  if (value.length === 0) message = I18N_STRINGS.REQUIRED_ZIP_CODE;
  else if (value.length !== 4) message = I18N_STRINGS.INVALID_ZIP_CODE;

  return {
    formattedValue: value,
    errorState: {
      message,
      error: message !== '',
    },
  };
};

export default validateZipCode;
